function asRecord(value: unknown): Record<string, unknown> | null {
  return value !== null && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

function trimmedString(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Returns the stable batch id for a retained Codex spawn envelope.
 *
 * Both legacy collaboration items and native multi-agent v2 activity use the
 * spawn call id as their batch identity. Completed v2 snapshots deliberately
 * do not seed a batch unless the matching started snapshot was retained.
 */
export function codexSubagentSpawnBatchId(payloadValue: unknown): string | null {
  const payload = asRecord(payloadValue);
  const data = asRecord(payload?.data);
  const item = asRecord(data?.item ?? data);
  const isLegacySpawn =
    payload?.itemType === "collab_agent_tool_call" &&
    item?.type === "collabAgentToolCall" &&
    item.tool === "spawnAgent";
  const isV2Spawn =
    payload?.itemType === "subagent_activity" &&
    item?.type === "subAgentActivity" &&
    item.kind === "started";
  return isLegacySpawn || isV2Spawn ? trimmedString(item?.id) : null;
}
